export default {
      id: "check-usage",
      viewBox: "0 0 11 8",
      url: __webpack_public_path__ + "sprite.1789552432127.svg#check-usage",
      toString: function () {
        return this.url;
      }
    }